// Filename - App.js

// Importing modules
import * as React from "react";
import { App as Routes } from "./Routes";
import AuthProvider from "react-auth-kit";
import createStore from "react-auth-kit/createStore";
import "./App.css";
import {refresh} from "./refresh";

function App() {
  return (
    <AuthProvider store={store}>
      <Routes />
    </AuthProvider>
  );
}


const store = createStore({
  authName: "_auth",
  authType: "cookie",
  cookieDomain: window.location.hostname,
  cookieSecure: window.location.protocol === "https:",
  refresh: refresh
});

export default App;
